export const channel = [
  { value: "A", label: "전체" },
  { value: "C", label: "일반" },
  { value: "K", label: "카카오" },
  { value: "N", label: "네이버" },
  { value: "G", label: "구글" },
  { value: "F", label: "페이스북" },
];
export const job = [
  { value: "A", label: "전체" },
  { value: "W", label: "농업인" },
  { value: "F", label: "귀농 희망자" },
  { value: "N", label: "귀촌 희망자" },
  { value: "E", label: "농산업기업체" },
  { value: "O", label: "지자체 담당자" },
  { value: "P", label: "정부부처(공공기관)" },
  { value: "C", label: "농산물 유통" },
  { value: "G", label: "기타" },
  { value: "B", label: "부동산 중개" },
  { value: "U", label: "선택안함" },
];

export const media = [
  { value: "A", label: "전체" },
  { value: "N", label: "네이버" },
  { value: "G", label: "구글" },
  { value: "M", label: "메타" },
  { value: "T", label: "트랜스파머" },
];
export const landing = [
  { value: "A", label: "전체" },
  { value: "price", label: "가격분석" },
  { value: "house", label: "내 집 짓기" },
  { value: "consulting", label: "컨설팅" },
  { value: "aifarm", label: "내 농장 진단" },
  { value: "findland", label: "농지 찾기" },
  { value: "pension", label: "농지 연금" },
];

export const memebrinfo = [
  {
    userKey: "29b420b0-0aa6-4add-8bd7-cb846e62e455",
    email: "so4111@naver.com",
    loginType: "네이버",
    name: "소정욱",
    birthYear: "",
    gender: "",
    phone: "01036536554",
    category: "기타",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 14:16:26",
    isDeleted: "N",
    isAdmin: "N",
    landing: "pension",
    referer: {
      NaPm: "ct=m0946gwg|ci=0yO0002-JqDAc5jxZvmM|tr=sa|hk=6be86e8b0d4d0e1b99514df83b30b45ce22bc535|nacn=5oOYBMAIQk7J",
      utm_id: "n_paidsearch",
      utm_medium: "paidsearch_annuity",
      utm_source: "naver",
      utm_campaign: "paidsearch_landing",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EB%86%8D%EC%A7%80_%EA%B0%80%EA%B2%A9_%ED%99%95%EC%9D%B8%EB%B6%80%ED%84%B0_%EB%86%8D%EC%A7%80%EC%97%B0%EA%B8%88_%EA%B3%84%ED%9A%8D%EA%B9%8C%EC%A7%80_%ED%95%9C%EB%B2%88%EC%97%90?utm_source=naver&utm_medium=paidsearch_annuity&utm_campaign=paidsearch_landing&utm_id=n_paidsearch&NaPm=ct%3Dm0946gwg%7Cci%3D0yO0002%2DJqDAc5jxZvmM%7Ctr%3Dsa%7Chk%3D6be86e8b0d4d0e1b99514df83b30b45ce22bc535%7Cnacn%3D5oOYBMAIQk7J",
    lastVisitTime: "2024-08-25T14:16:26.000Z",
  },
  {
    userKey: "bd201ee3-0b11-4f28-9abd-11b9e05e21f3",
    email: "hannwi@hanmail.net",
    loginType: "카카오",
    name: "김광희",
    birthYear: "",
    gender: "",
    phone: "01099303114",
    category: "선택안함",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:32:20",
    isDeleted: "N",
    isAdmin: "N",
    landing: "",
    referer: "",
    fullReferer: "",
    lastVisitTime: "2024-08-25T13:32:20.000Z",
  },
  {
    userKey: "a0a9cd97-4091-45fa-9b2b-0c87c9c61229",
    email: "chk6415@hanmail.net",
    loginType: "카카오",
    name: "장효규",
    birthYear: "",
    gender: "",
    phone: "01086283193",
    category: "농산물 유통",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:18:47",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      gclid:
        "CjwKCAjwiaa2BhAiEiwAQBgyHsEAbmcswr3c6jN5uNvVPktSobMpn6g5ZFqzpK36UZEOxuCj_0jPvxoC5WcQAvD_BwE",
      utm_id: "signup",
      gad_source: "1",
      utm_medium: "cpc",
      utm_source: "google",
      utm_content: "price_loss_google",
      utm_campaign: "price_loss_google",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=google&utm_medium=cpc&utm_campaign=price_loss_google&utm_id=signup&utm_content=price_loss_google&gad_source=1&gclid=CjwKCAjwiaa2BhAiEiwAQBgyHsEAbmcswr3c6jN5uNvVPktSobMpn6g5ZFqzpK36UZEOxuCj_0jPvxoC5WcQAvD_BwE",
    lastVisitTime: "2024-08-25T13:29:57.000Z",
  },
  {
    userKey: "83083f5a-2bb0-4e01-927e-9a8351aad952",
    email: "mdw0526@kakao.com",
    loginType: "카카오",
    name: "문대우",
    birthYear: "",
    gender: "",
    phone: "01087098122",
    category: "기타",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:16:46",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      gclid:
        "CjwKCAjwiaa2BhAiEiwAQBgyHkl3SV_VXQQM-PseutM0niHwwgYyy878kO3BWeENLG4yUeFMY_ZS1xoCCj8QAvD_BwE",
      utm_id: "promotion",
      gad_source: "1",
      utm_medium: "cpc",
      utm_source: "google",
      utm_campaign: "landsearch",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=google&utm_medium=cpc&utm_campaign=landsearch&utm_id=promotion&gad_source=1&gclid=CjwKCAjwiaa2BhAiEiwAQBgyHkl3SV_VXQQM-PseutM0niHwwgYyy878kO3BWeENLG4yUeFMY_ZS1xoCCj8QAvD_BwE",
    lastVisitTime: "2024-08-25T13:19:19.000Z",
  },
  {
    userKey: "f8338166-b578-4d82-b7cd-4a6a8ddf3466",
    email: "cpu3@naver.com",
    loginType: "네이버",
    name: "권대선",
    birthYear: "",
    gender: "",
    phone: "01036890003",
    category: "기타",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:14:10",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      gclid:
        "CjwKCAjwiaa2BhAiEiwAQBgyHsqHy4Q23WqSA5udzVgpFvKbj6USxWGITR6Qfa55C1q9NBssDZ_aAhoCRqsQAvD_BwE",
      utm_id: "promotion",
      utm_medium: "cpc",
      utm_source: "google",
      utm_campaign: "landsearch",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=google&utm_medium=cpc&utm_campaign=landsearch&utm_id=promotion&gclid=CjwKCAjwiaa2BhAiEiwAQBgyHsqHy4Q23WqSA5udzVgpFvKbj6USxWGITR6Qfa55C1q9NBssDZ_aAhoCRqsQAvD_BwE",
    lastVisitTime: "2024-08-25T13:14:11.000Z",
  },
  {
    userKey: "104cc4e1-e44a-4166-8c09-170f18f5b655",
    email: "kjohnson@hanmail.net",
    loginType: "네이버",
    name: "조순구",
    birthYear: "",
    gender: "",
    phone: "01050174716",
    category: "귀촌 희망자",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:05:50",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      fbclid:
        "IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
      utm_id: "promotion",
      utm_medium: "cpc",
      utm_source: "meta",
      utm_campaign: "nowprice1",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=meta&utm_medium=cpc&utm_campaign=nowprice1&utm_id=promotion&fbclid=IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
    lastVisitTime: "2024-08-25T14:12:50.000Z",
  },
  {
    userKey: "104cc4e1-e44a-4166-8c09-170f18f5b655",
    email: "kjohnson@hanmail.net",
    loginType: "네이버",
    name: "조순구",
    birthYear: "",
    gender: "",
    phone: "01050174716",
    category: "귀촌 희망자",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:05:50",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      fbclid:
        "IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
      utm_id: "promotion",
      utm_medium: "cpc",
      utm_source: "meta",
      utm_campaign: "nowprice1",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=meta&utm_medium=cpc&utm_campaign=nowprice1&utm_id=promotion&fbclid=IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
    lastVisitTime: "2024-08-25T14:12:50.000Z",
  },
  {
    userKey: "104cc4e1-e44a-4166-8c09-170f18f5b655",
    email: "kjohnson@hanmail.net",
    loginType: "네이버",
    name: "조순구",
    birthYear: "",
    gender: "",
    phone: "01050174716",
    category: "귀촌 희망자",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:05:50",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      fbclid:
        "IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
      utm_id: "promotion",
      utm_medium: "cpc",
      utm_source: "meta",
      utm_campaign: "nowprice1",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=meta&utm_medium=cpc&utm_campaign=nowprice1&utm_id=promotion&fbclid=IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
    lastVisitTime: "2024-08-25T14:12:50.000Z",
  },
  {
    userKey: "104cc4e1-e44a-4166-8c09-170f18f5b655",
    email: "kjohnson@hanmail.net",
    loginType: "네이버",
    name: "조순구",
    birthYear: "",
    gender: "",
    phone: "01050174716",
    category: "귀촌 희망자",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:05:50",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      fbclid:
        "IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
      utm_id: "promotion",
      utm_medium: "cpc",
      utm_source: "meta",
      utm_campaign: "nowprice1",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=meta&utm_medium=cpc&utm_campaign=nowprice1&utm_id=promotion&fbclid=IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
    lastVisitTime: "2024-08-25T14:12:50.000Z",
  },
  {
    userKey: "104cc4e1-e44a-4166-8c09-170f18f5b655",
    email: "kjohnson@hanmail.net",
    loginType: "네이버",
    name: "조순구",
    birthYear: "",
    gender: "",
    phone: "01050174716",
    category: "귀촌 희망자",
    agriculturalNum: "",
    nick: "",
    createdDate: "2024-08-25 13:05:50",
    isDeleted: "N",
    isAdmin: "N",
    landing: "price",
    referer: {
      fbclid:
        "IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
      utm_id: "promotion",
      utm_medium: "cpc",
      utm_source: "meta",
      utm_campaign: "nowprice1",
    },
    fullReferer:
      "https://transfarmer.co.kr/promotion/%EC%A0%95%ED%99%95%ED%95%9C-%ED%86%A0%EC%A7%80-%EB%86%8D%EC%A7%80-%EC%A3%BC%ED%83%9D-%EA%B0%80%EA%B2%A9%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EB%8A%94-%EB%B0%A9%EB%B2%95/?utm_source=meta&utm_medium=cpc&utm_campaign=nowprice1&utm_id=promotion&fbclid=IwY2xjawE3jK9leHRuA2FlbQEwAAEdrkvlmQzR5gTTATzQi8DNJ5kF4ufzUutP2FUcUj4hfNUU2rVNsOgDJ3G4_aem_QoORJOyu-mfo6wsCoJQAuA",
    lastVisitTime: "2024-08-25T14:12:50.000Z",
  },
];
